<template>
	<div class="inventory-navi">
		<ul class="list">
			<li>
				<h2>{{ isCoupang ? '상품등록 관리' : '상품관리' }}</h2>
					<ul class="depth2">
						<router-link tag="li" :to="{ path: '/inventoryWrite', query: $route.query }" active-class="active">
							<a>- 상품등록<!--商品登记--></a>
						</router-link>
						<router-link tag="li" :to="{ path: '/itemXlsUpload', query: $route.query }" active-class="active">
							<a>- {{ isCoupang ? '대량등록(Excel)' : '상품엑셀등록' }}</a>
						</router-link>
						<router-link tag="li" :to="{ path: '/inventoryItem', query: $route.query }" active-class="active">
							<a>- {{ isCoupang ? '상품등록 현황' : '상품등록현황' }}</a>
						</router-link>
					</ul>
			</li>
			<li>
				<h2>입고관리</h2>
				<ul class="depth2">
					<router-link tag="li" :to="{ path: '/warehouseWrite', query: $route.query }" active-class="active">
						<a>- 입고신청<!--入库申请--></a>
					</router-link>
					<router-link tag="li" :to="{ path: '/warehouseXlsUpload', query: $route.query }" active-class="active">
						<a>- {{ isCoupang ? '대량입고신청(Excel)' : '입고엑셀등록' }}</a>
					</router-link>
					<router-link tag="li" :to="{ path: '/inventoryWarehouse', query: $route.query }" active-class="active">
						<a>- {{ isCoupang ? '입고 신청 현황' : '입고현황' }}</a>
					</router-link>
					<router-link tag="li" :to="{ path: '/inventoryWarehouseComplete', query: $route.query }" active-class="active">
						<a>- {{ isCoupang ? '입고 완료 현황' : '입고 후 보관 신청' }}</a>
					</router-link>
				</ul>
			</li>
			<li>
				<h2>발송관리</h2>
				<ul class="depth2">
					<router-link tag="li" :to="{ path: '/inventoryPackingWrite', query: $route.query }" active-class="active">
						<a>- 발송신청<!--发送申请--></a>
					</router-link>
					<router-link tag="li" :to="{ path: '/packingXlsUpload', query: $route.query }" active-class="active">
						<a>- 발송엑셀등록</a>
					</router-link>
					<router-link tag="li" :to="{ path: '/inventoryPacking', query: $route.query }" active-class="active">
						<a>- 발송현황</a>
					</router-link>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
	import { safePush } from '@/utils/router';
	export default {
		computed: {
			isCoupang() {
				return this.$route.query.type === 'coupang';
			}
		},
		methods: {
			onNav(url){
				const query = { ...this.$route.query };
				safePush(this.$router, { path: url, query: query });
			}
		}
	}
	
	
	
</script>

<style scoped>
	.inventory-navi {
	    max-width: 800px;
	    margin: 0 auto 80px;
	}
	.inventory-navi .list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	    display: flex;
	    gap: 0 30px;
	}
	.inventory-navi .list > li {
	    flex: 1;
	}
	.inventory-navi h2 {
	    padding: 18px 14px;
	    background: #FFFFFF;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	    border-radius: 10px;
	    font-weight: 700;
	    font-size: 17px;
	    line-height: 20px;
	    color: #111111;
	    margin: 0 0 10px;
	    text-align: center;
	}
	.inventory-navi .depth2 {
		margin: 0;
		padding: 0 30px;
		list-style: none;
		background: #fff;
		color: var(--background-color);
		border: 1px solid #F1F2F3;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		transition: 0.25s;
		height: 156px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		justify-content: center;
	}
	.inventory-navi .depth2 > li {
	    font-size: 16px;
	    line-height: 30px;
		cursor: pointer;
	}
	.inventory-navi .depth2 > li a {
		display: block;
		color: inherit;
		text-decoration: none;
	}
	.inventory-navi .depth2 > li:hover a{
		color:var(--main-color);
	}
	@media (max-width: 768px) {
		.inventory-navi .list {
		    margin: 20px 10px;
		}
		.inventory-navi .depth2 {
			padding: 0 10px;
			height: 125px;
		}
	}
</style>